import { projecdetails } from '../../utils/config.js'
import Meta from '../meta/meta.component.jsx'
import './portofoli.style.css'

const Portfolio = () => {
  return (
    <section id="portfolio">
      <Meta title={'My portfolio'} />
      <h5>My Recent work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
        {projecdetails.map((project) => (
          <article className="portfolio_item" key={project.name}>
            <div className="portfoli_item_image">
              <img src={project.imagepath} alt={project.name} />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                marginTop: '10px',
              }}
            >
              <h3>{project.name}</h3>

              <div className="btn_wrapper">
                <a
                  href={project.projecturl}
                  className="btn btn-primary"
                  target="_blank"
                >
                  Live demo
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Portfolio
